import { SEO } from '../components/SEO';

export const CookiePolicy: React.FC = () => {
  return (
    <>
      <SEO
        title="Cookie Policy | Your Casinos"
        description="Cookie policy for Your Casinos. Learn about how we use cookies and similar technologies."
        canonical="/policies/cookies"
      />

      <div className="min-h-screen bg-black py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">
            Cookie Policy
          </h1>
          <div className="glass-card p-8 space-y-6 text-gray-300 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">What Are Cookies?</h2>
              <p>
                Cookies are small text files stored on your device when you visit a website. They help 
                websites remember your preferences and improve your browsing experience.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">How We Use Cookies</h2>
              <p>We use cookies for the following purposes:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>Essential Cookies:</strong> Required for the website to function properly</li>
                <li><strong>Analytics Cookies:</strong> Help us understand how visitors use our website</li>
                <li><strong>Preference Cookies:</strong> Remember your settings and preferences</li>
                <li><strong>Marketing Cookies:</strong> Used to deliver relevant advertisements</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Managing Cookies</h2>
              <p>
                You can control cookies through your browser settings. Most browsers allow you to refuse 
                cookies or delete them. However, blocking cookies may affect website functionality.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Third-Party Cookies</h2>
              <p>
                We may use third-party services that set their own cookies. These services help us 
                analyze traffic and provide relevant content. We do not control these cookies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Contact Us</h2>
              <p>
                If you have questions about our use of cookies, please contact us through our website.
              </p>
            </section>

            <section>
              <p className="text-sm text-gray-500">
                Last updated: {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

